import { Component, OnInit, inject } from '@angular/core';
import { DefaultStateService, LoggedInUserService } from '@formbird/services';

@Component({
    selector: 'ft-default',
    template: ``,
    standalone: true,
})
export class DefaultComponent implements OnInit {
  private defaultStateService = inject(DefaultStateService);
  private loggedInUserService = inject(LoggedInUserService);


  async ngOnInit() {
    let user = this.loggedInUserService.getLoggedInUser();
    if (!user?.account?.systemHeader) { // #30671 if user not loaded, load user
      const loggedUser: any = await this.loggedInUserService.loadLoggedUser();
      user = loggedUser?.user;
    }

    this.defaultStateService.changeToDefaultState('/form', user);
  }

}
